import { useTestStore } from '@/store/useTestStore';
import { TouchTest, ViewportTest, ScrollTest, MediaApiTest, BatteryTest, PwaTest, FormKeyboardTest, NetworkCapTest } from '@/tests/mobile';

const MOBILE_TEST_MAP: Record<string, React.FC<{ autoRun: boolean; autoNonce: number }>> = {
  'mobile-touch': TouchTest,
  'mobile-viewport': ViewportTest,
  'mobile-scroll': ScrollTest,
  'mobile-media': MediaApiTest,
  'mobile-battery': BatteryTest,
  'mobile-pwa': PwaTest,
  'mobile-form': FormKeyboardTest,
  'mobile-network': NetworkCapTest,
};

export function MobileTestSuite() {
  const { activeView, autoRunning, autoNonce, getRunOrder } = useTestStore();
  const order = getRunOrder();
  const activeAutoTestId = autoRunning ? order[useTestStore.getState().autoIdx] : null;

  const Component = MOBILE_TEST_MAP[activeView];
  if (!Component) return null;

  return (
    <Component
      autoRun={activeAutoTestId === activeView}
      autoNonce={autoNonce}
    />
  );
}
